<template>
    <div
        class="md cart-caption"
        :class="[needBottomLine? 'has-border': '']"
    >
        <slot></slot>
        <div class="name">{{ caption }}</div>
        <div v-if="minorCaption" class="lable">{{ minorCaption }}</div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        props: {
            caption: {
                type: String,
                require: false,
                default: ''
            },
            minorCaption: {
                type: String,
                require: false,
                default: ''
            },
            needBottomLine: {
                type: Boolean,
                require: false,
                default: true
            },
        },
        computed: {
            ...mapState([
                'user',
            ])
        },
    }
</script>

<style scoped lang="scss">

    .md.cart-caption {
        display: flex;
        padding-top: $interval-l;
        box-sizing: border-box;

        div {
            display: flex;
            align-items: center;
            padding: 0 $interval-m;
        }

        .func {
            transition: $transition;
            cursor: pointer;

            &:hover {
                opacity: $opacity-m
            }
        }

        .name {
            flex: 1;
            justify-content: center;
            font-size: $font-size-xxl;
            font-weight: bold;
        }

        .lable {

        }
    }
</style>
